import { useRouter } from 'next/router';

import { Box } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../../../../hooks/queries/properties';
import accessUtils from '../../../../../utils/accessUtils';

import SFCostAndFeesTotalMonthlyPriceWithFeeAlert from '../../../../../../srcLegacy/shared/components/Alerts/SFCostAndFeesTotalMonthlyPriceWithFeeAlert';

import CostsAndFeesFormField from '../../../../PostingPath/CostsAndFeesFormField';
import SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert from '../../../../SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert';

const CostsAndFeesContent = () => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const isTotalMonthlyPriceWithFeeEligible = listingDetails?.totalMonthlyPriceWithFeeNotice?.isEligible ?? false;
  const isOptInTotalMonthlyPriceWithFeeEligible = listingDetails?.totalMonthlyPriceWithFee?.isOptInEligible ?? false;

  const canAccessTotalMonthlyPriceWithFee = accessUtils.canAccessTotalMonthlyPriceWithFee({
    isEligible: isTotalMonthlyPriceWithFeeEligible,
  });

  return (
    <div data-testid="CostsAndFeesContent" data-group-title="CostsAndFees">
      {canAccessTotalMonthlyPriceWithFee && <SFCostAndFeesTotalMonthlyPriceWithFeeAlert />}
      {isOptInTotalMonthlyPriceWithFeeEligible && (
        <SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert triggerLocation="posting_path_review" />
      )}

      <Box data-testid="CostsAndFeesReviewSection">
        <CostsAndFeesFormField displayedLocation="posting_path_review" />
      </Box>
    </div>
  );
};

export default CostsAndFeesContent;
